import { render, staticRenderFns } from "./DefaultError.vue?vue&type=template&id=49a8f20a&scoped=true"
import script from "./DefaultError.vue?vue&type=script&lang=js"
export * from "./DefaultError.vue?vue&type=script&lang=js"
import style0 from "./DefaultError.vue?vue&type=style&index=0&id=49a8f20a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a8f20a",
  null
  
)

export default component.exports